import { render, staticRenderFns } from "./LogsDisplay.vue?vue&type=template&id=2a644482&scoped=true&"
import script from "./LogsDisplay.vue?vue&type=script&lang=js&"
export * from "./LogsDisplay.vue?vue&type=script&lang=js&"
import style0 from "./LogsDisplay.vue?vue&type=style&index=0&id=2a644482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a644482",
  null
  
)

export default component.exports